// extracted by mini-css-extract-plugin
module.exports = {"pageTitle":"Reports_pageTitle__2KIoR","mainTableContainer":"Reports_mainTableContainer__2ZFuv","countryBox":"Reports_countryBox__iXCrU"};